module.exports = __webpack_public_path__ + "static/media/epaper-desktop.5a96161e.jpg";